import { IStringTool } from "../core/IStringTool"

/**
 * Input for `BoundingClientRectTool`.
 */
interface BoundingClientRectInput {
  /** The DOM element to retrieve bounding rect from. */
  element: HTMLElement
}

/**
 * Tool for accessing `getBoundingClientRect()` in a consistent, testable way.
 */
export default class BoundingClientRectTool
  implements IStringTool<BoundingClientRectInput, DOMRect>
{
  /**
   * @returns The bounding client rect of the provided element.
   */
  process({ element }: BoundingClientRectInput): DOMRect {
    return element.getBoundingClientRect()
  }
}
